import { ReactNode, createContext, useContext } from "react";
import { useFilterMember } from "./filter-member.hook";

const FilterMemberContext = createContext(
  {} as ReturnType<typeof useFilterMember>
);
export function useFilterMemberContext() {
  return useContext(FilterMemberContext);
}

interface FilterMemberProviderProps {
  children: ReactNode;
}
export function FilterMemberProvider({
  children,
}: FilterMemberProviderProps) {
  return (
    <FilterMemberContext.Provider value={useFilterMember()}>
      {children}
    </FilterMemberContext.Provider>
  );
}